import { DigitalIdentityHub } from "../../global/core";
import { Common } from "../us/us.common";
import { ENDPOINTS } from "../../constants/endpoints";

const activeModules = ["HiddenFields", "EmailVerification", "TransactionalEmails", "Deeplink", "ConsentWidget", "EmailChange", "CustomValidation"];

const digitalIdentityHub = new DigitalIdentityHub(activeModules);

digitalIdentityHub.addModule(Common);
digitalIdentityHub.addModule({
  name: "Us-vaccinesSit",
  ready() {
    window.DigitalIdentityHub.utilities.setLanguage("en-US");
  },
  init() {
    janrain.settings.appUrl = "https://merck-global.rpxnow.com/";
    janrain.settings.httpLoadUrl = "http://widget-cdn.rpxnow.com/load/merck-global";
    janrain.settings.httpsLoadUrl = "https://rpxnow.com/load/merck-global";
    janrain.settings.capture.captureServer = "https://merck-staging.us-dev.janraincapture.com";
    janrain.settings.capture.appId = "9zy6bfks5pytt2b73mn5e79khv";
    // Merck Vaccines SIT Client ID
    janrain.settings.capture.clientId = "ar269g8drq8d4egg5jpzer74menqac8x";
    janrain.settings.capture.federateServer = "https://merck-sit-dev.us.janrainsso.com";
    janrain.settings.capture.redirectUri = "http://localhost/";
    janrain.settings.capture.flowVersion = "HEAD"; // Using HEAD for UAT 11/20/19 NT
    janrain.settings.capture.profileUpdatedEmailConfigured = true;

    window.DigitalIdentityHub.settings.transactionalEmailsEndpoint = ENDPOINTS.US_SIT_TRANSACTIONAL_EMAILS;
    window.DigitalIdentityHub.settings.transactionalEmailsKey = ENDPOINTS.US_SIT_TRANSACTIONAL_EMAILS_KEY;
    window.DigitalIdentityHub.settings.deeplinkEndpoint = ENDPOINTS.US_SIT_DEEPLINK;
    window.DigitalIdentityHub.settings.consentHubCustomerEndpoint = ENDPOINTS.US_SIT_CONSENT_HUB_CUSTOMER;

    window.DigitalIdentityHub.settings.htmlEndpoint = location.hostname === "localhost" ? "html/forms.html" : `https://dmc-front-end-package-sit.mrk-mdlwr.com/${VERSION}/us-vaccines/html/forms.html`;
    window.DigitalIdentityHub.settings.emailChangeEndpoint = "https://dmc-api-us-sit.mrk-mdlwr.com/transactional-emails";
    window.DigitalIdentityHub.modules.ConsentWidget.consentHubEndpoint = `${ENDPOINTS.US_SIT_COH_WIDGET_BASE_URL}/MCConsent/app.dc073a963a5e34f295f1.js`;
    window.DigitalIdentityHub.modules.ConsentWidget.consentHubCssEndpoint = `${ENDPOINTS.US_SIT_COH_WIDGET_BASE_URL}/MCConsent/style.dc073a963a5e34f295f1.css`;
  }
});

export default digitalIdentityHub;
